import React from 'react';
import {DEVICE_OPTIONS, DevicePreset} from './devicePresets';

interface Props {
    device: DevicePreset;
    onChange: (device: DevicePreset) => void;
}

export function DeviceSwitcher({device, onChange}: Props) {
    return (
        <div className="DemoPanel__devices" role="group" aria-label="Preview device">
            {DEVICE_OPTIONS.map((opt) => (
                <button
                    key={opt.value}
                    className={`DemoPanel__deviceBtn${device === opt.value ? ' DemoPanel__deviceBtn--active' : ''}`}
                    onClick={() => onChange(opt.value)}
                    aria-pressed={device === opt.value}
                    aria-label={`Preview as ${opt.label}`}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    );
}
